import type { FC } from 'react';
import { Link } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from '../../../../ui-components';

interface BrandShopLinkProps {
    brandName: string;
    brandShopUrl: string;
}

export const BrandShopLink: FC<BrandShopLinkProps> = ({ brandName, brandShopUrl }) => (
    <Button variant="text-button-no-hover" padding="0px">
        <Link
            href={brandShopUrl}
            data-testid="buy-box-brand-shop-link"
            className="whitespace-nowrap"
            textStyle="body-base"
        >
            <FormattedMessage
                id="buy.box.brand.shop.link"
                defaultMessage="Shop {brandName}"
                values={{ brandName }}
            />
        </Link>
    </Button>
);

BrandShopLink.propTypes = {
    brandName: PropTypes.string.isRequired,
    brandShopUrl: PropTypes.string.isRequired,
};
